import React from "react";
import Gradient from "../Gradient";
import HandShakeImg from "../../assets/images/hand-shake.png";
import StoneImg from "../../assets/images/bottom-stone.png";
import CalendlyCustomButton from "../CalendlyCustomButton";

const ContactsSection = ({ data, anchorId }) => {
  if (!data) return null;

  const { title, subTitle, description, socialMedia } = data;

  return (
    <section className="section contacts-section flex-wrapper" id={anchorId}>
      <div className="flex-container section-container">
        <div className="contacts-info">
          <span className="subTitle">{subTitle}</span>
          <h2>{title}</h2>
          <p>{description}</p>
          <div className="social">
            {socialMedia.map((item) => {
              return (
                <div key={item.id} className="social-element">
                  <a href={item.url} target="_blank" rel="noopener noreferrer" aria-label={item.label}>
                    <img src={item.logo?.url} alt={item.label} />
                  </a>
                </div>
              );
            })}
            <CalendlyCustomButton />
          </div>
        </div>
        <div className="contacts-images">
          <img
            className="contacts-images__small"
            src={HandShakeImg}
            alt="handshake"
          />
          {/* <img className="contacts-images__big" src={PersonImg} alt="Person" /> */}
        </div>
      </div>
      <div className="contacts-stone">
        <img src={StoneImg} alt="stone" />
      </div>
      <Gradient
        imageName="gradient10"
        className="gradientRightUp"
        right="-75%"
        bottom="0"
      />
    </section>
  );
};

export default ContactsSection;
